module.exports = __webpack_public_path__ + "img/IMG_0231.8acfd35c.jpg";